<template>
    <div class="field is-horizontal">
            <div :class="labelClasses" class="field-label">
                <label class="label"> <slot name="label"></slot></label>
            </div>
        <div class="field-body">
            <div class="field">
            <div class="control">
                <slot name="body"></slot>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        labelClasses: {
            default: 'is-normal'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form/HorizontalInput.vue